import { createFileRoute } from '@tanstack/react-router';
import Hero from '../components/Hero';
import About from '../components/About';
import Rules from '../components/Rules';
import Stats from '../components/Stats';
import Members from '../components/Members';
import FAQ from '../components/FAQ';
import Join from '../components/Join';

export const Route = createFileRoute('/')({
  component: () => (
    <>
      <Hero />
      <About />
      <Rules />
      <Stats />
      <Members />
      <FAQ />
      <Join />
    </>
  ),
});



